import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapCrmStageFromServer = getDataMapper({
    id: mapField("id", Number),
    const: mapField("const"),
    title: mapField("title", String),
    color: mapField("color"),
    isAuto: mapField("is_auto", Boolean),
    sort: mapField("sort", Number),
});

export const mapCrmStagesFromServer = mapArray(mapCrmStageFromServer);
